import React from "react";

interface ContextMenuProps {
  menuOpen: boolean;
  toggleMenuOpen: () => void;
}

export const ContextMenu = React.createContext<ContextMenuProps>(null);